module.exports = __webpack_public_path__ + "assets/img/two-tab6-on.494aae10.png";